module.exports = __webpack_public_path__ + "7e2162f9d3c71c605c0cd030b9684149.otf";